import { GET_BOOKING, GET_BOOKING_DISCOUNT, GET_AGGREGATE_EXTRA_PRICE, GET_BOOKING_TRAVELLERS_TOTAL, GET_FLEX_EXTRAS, GET_FLEX_EXTRA_ID, GET_FLEX_EXTRA_SELECTED } from '../../../../../store/booking/getter-types';
import moment from "../../../../../plugins/moment";
import { mapGetters } from 'vuex';
import { GET_EXTRA_NO_PROMO_PRICE } from '../../../../../store/nights/getter-types';

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: () => "Resumen de la reserva"
    },
    date: {
      type: String,
      required: false,
      default: () => ''
    },
    origin: {
      type: String,
      required: false,
      default: () => ''
    },
    destiny: {
      type: String,
      required: false,
      default: () => ''
    },
    travellersTotal: {
      type: Number,
      required: false,
      default: () => undefined
    },
    travellerPrice: {
      type: Number,
      required: false,
      default: () => 0
    },
    totalPrice: {
      type: Number,
      required: false,
      default: () => undefined
    },
    bookingExtras: {
      type: Array,
      required: false,
      default: () => []
    },
    items: [
      {
        icon: {
          type: String,
          required: true,
          default: () => ""
        },
        label: {
          type: String,
          required: true,
          default: () => "Item title"
        }
      }
    ],
    details: undefined
  },
  data() {
    return {
      summaryItems: [
        {
          icon: "/img/icons/airplane.svg",
          label: `${this.$t('shared.from')} ${this.origin}`
        },
        {
          icon: "/img/icons/user.svg",
          label: `${this.travellersTotal} ${this.$tc('passenger', this.travellersTotal)}`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: this.date
        },
        {
          icon: "/img/icons/location.svg",
          label: `${this.$t('shared.destiny')} ${this.destiny}`
        }
      ],
      travellers: {
        icon: "/img/icons/user.svg",
        label: `${this.travellersTotal} ${this.travellersTotal > 1 ? 'pasajeros' : 'pasajero'}`
      },

      localExtras: this.extras,
    };
  },
  computed: {
    ...mapGetters({
      flexExtraSelected: GET_FLEX_EXTRA_SELECTED,
    }),
    totalPassengers(){
      return this.$store.getters[GET_BOOKING_TRAVELLERS_TOTAL]
    },
    discount() {
      return this.$store.getters[GET_BOOKING_DISCOUNT];
    },
    booking(){
      return this.$store.getters[GET_BOOKING];
    },
    outgoingDeparture(){
      return moment(this.booking.outgoingFlight.departure.datetime).format('LT');
    },
    outgoingArrival(){
      return moment(this.booking.outgoingFlight.arrival.datetime).format('LT');
    },
    returnDeparture(){
      return moment(this.booking.returnFlight.departure.datetime).format('LT');
    },
    returnArrival(){
      return moment(this.booking.returnFlight.arrival.datetime).format('LT');
    },
    summaryItemsIn(){
      return [
        {
          icon: "/img/icons/airplane.svg",
          label: `${this.origin} (${this.$route.query.origen}) - ${this.destiny} (${this.$route.query.destino})`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: `${this.date} · ${this.outgoingDeparture} - ${this.outgoingArrival}`
        },
      ]
    },
    summaryItemsOut(){
      return [
        {
          icon: "/img/icons/arrive.svg",
          label: `${this.destiny} (${this.$route.query.destino}) - ${this.origin} (${this.$route.query.origen})`
        },
        {
          icon: "/img/icons/calendar.svg",
          label: `${this.date} · ${this.returnDeparture} - ${this.returnArrival}`
        },
      ]
    },
  },
  methods: {
    getAggregateExtraPrice(extra) {
      return this.$store.getters[GET_AGGREGATE_EXTRA_PRICE](extra);
    },
    // getAggregateFlexExtraPrice(extra) {
    //   return this.$store.getters[GET_AGGREGATE_EXTRA_PRICE](extra);
    // }
  },

};
